import { createContext, useContext } from 'react'
import type { EntityCodeOpenRequest } from './entityCodeTypes'

export type EntityCodeModalContextValue = {
  openEntityDetail: (req: EntityCodeOpenRequest) => void
}

export const EntityCodeModalContext = createContext<EntityCodeModalContextValue | null>(null)

export const useEntityCodeModal = (): EntityCodeModalContextValue | null =>
  useContext(EntityCodeModalContext)
